/**
 * Fine editorial seam between sections: a hairline that fades from
 * transparent to gold and back, with a small centred diamond.
 */
export default function SectionDivider() {
  return (
    <div aria-hidden className="relative bg-transparent" data-testid="section-divider">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative h-px bg-gradient-to-r from-transparent via-[#C9A84C]/55 to-transparent">
          <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rotate-45 bg-[#C9A84C]" />
        </div>
      </div>
    </div>
  );
}
